import { createEntityAdapter } from "@reduxjs/toolkit"

export const actionButtonsAdapter =
    createEntityAdapter<Resources.ActionButton>()
export const actionButtonSelector = actionButtonsAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.actionButtons,
)

export const attachmentsAdapter = createEntityAdapter<Resources.Attachment>()
export const attachmentSelector = attachmentsAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.attachments,
)

export const collectionsAdapter = createEntityAdapter<Resources.Collection>()
export const collectionSelector = collectionsAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.collections,
)

export const conceptsAdapter = createEntityAdapter<Resources.Concept>()
export const conceptSelector = conceptsAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.concepts,
)

export const itemsAdapter = createEntityAdapter<Resources.Item>()
export const itemSelector = itemsAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.items,
)

export const workspacesAdapter = createEntityAdapter<Resources.Workspace>()
export const workspaceSelector = workspacesAdapter.getSelectors(
    (state: Resources.ResourceCatalog) => state.workspaces,
)
